import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { INDUSTRIES, SERVICES, CONTACT } from '../../site/nav';

export default function SiteFooter() {
  const { pathname } = useLocation();
  const section = (id) => (pathname === '/' ? `#${id}` : `/#${id}`);
  return (
    <footer className="py-10 md:py-12 px-4 border-t border-slate-200 bg-slate-50">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-6 md:gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/e.png" alt="Exitium" className="w-7 md:w-8 h-7 md:h-8 object-contain" />
              <span className="text-lg md:text-xl font-bold">EXITIUM</span>
            </div>
            <p className="text-slate-600 text-xs md:text-sm">Websites and online stores for furniture stores, restaurants, clinics and local services, each built around what makes the business money.</p>
          </div>
          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-sm md:text-base">Who we build for</h3>
            <ul className="space-y-2 text-slate-600 text-xs md:text-sm">
              {INDUSTRIES.map((i) => (
                <li key={i.id}><Link to={i.path} className="hover:text-blue-600 transition-colors inline-block py-1">{i.name}</Link></li>
              ))}
              <li><Link to="/websites" className="hover:text-blue-600 transition-colors inline-block py-1">All the sites</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-sm md:text-base">Furniture platform</h3>
            <ul className="space-y-2 text-slate-600 text-xs md:text-sm">
              {SERVICES.filter((s) => !s.group).map((s) => (
                <li key={s.slug}><Link to={s.path} className="hover:text-blue-600 transition-colors inline-block py-1">{s.name}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-sm md:text-base">Exitium</h3>
            <ul className="space-y-2 text-slate-600 text-xs md:text-sm">
              <li><a href={section('pricing')} className="hover:text-blue-600 transition-colors inline-block py-1">Pricing</a></li>
              <li><a href={section('faq')} className="hover:text-blue-600 transition-colors inline-block py-1">FAQ</a></li>
              <li><a href={CONTACT.liveSite} target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors inline-block py-1">Live example</a></li>
              <li><Link to="/dashboard" className="hover:text-blue-600 transition-colors inline-block py-1">Dashboard</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-3 md:mb-4 text-sm md:text-base">Company</h3>
            <ul className="space-y-2 text-slate-600 text-xs md:text-sm">
              <li><a href={CONTACT.calendlyUrl} className="hover:text-blue-600 transition-colors inline-block py-1">Contact</a></li>
              <li><Link to="/privacy-policy" className="hover:text-blue-600 transition-colors inline-block py-1">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-blue-600 transition-colors inline-block py-1">Terms of Service</Link></li>
              <li><Link to="/legal/ai-disclosure" className="hover:text-blue-600 transition-colors inline-block py-1">AI Disclosure</Link></li>
              <li><Link to="/legal/subprocessors" className="hover:text-blue-600 transition-colors inline-block py-1">Subprocessors</Link></li>
              <li><Link to="/legal/accessibility" className="hover:text-blue-600 transition-colors inline-block py-1">Accessibility</Link></li>
            </ul>
          </div>
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-semibold mb-3 md:mb-4 text-sm md:text-base">Get in Touch</h3>
            <p className="text-slate-600 text-xs md:text-sm"><a href={CONTACT.phoneLink} className="hover:text-blue-600">{CONTACT.phone}</a></p>
            <p className="text-slate-600 text-xs md:text-sm"><a href={`mailto:${CONTACT.supportEmail}`} className="hover:text-blue-600">{CONTACT.supportEmail}</a></p>
            <p className="text-slate-600 text-xs md:text-sm"><a href={`mailto:${CONTACT.salesEmail}`} className="hover:text-blue-600">{CONTACT.salesEmail}</a></p>
          </div>
        </div>
        <div className="border-t border-slate-200 pt-6 md:pt-8 text-center text-slate-500 text-xs md:text-sm">
          <p>© 2026 Exitium Labs. All rights reserved.</p>
          <div className="mt-4 flex justify-center">
            <Link to="/legal/accessibility" className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-slate-200 text-slate-600 hover:text-blue-600 hover:border-blue-500 transition-colors text-xs">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M9 12l2 2 4-4" /></svg>
              <span>Committed to WCAG 2.1 AA</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
